module.exports = __webpack_public_path__ + "img/stratup-brand-logo-1.dc4d40f2.png";